import React, { lazy, Suspense } from "react";
import { LoadingSpinner } from "lib/Spinner";
const EconomicForecast = lazy(() => import("pages/EconomicData/EconomicData"));

export const LazyEconomicData = () => (
  <Suspense fallback={<LoadingSpinner />}>
    <EconomicForecast />
  </Suspense>
);
